import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import * as svc from "../../api/cashService";
import { getApiErrorMessage } from "../../utils/apiError";

export const fetchCashAccounts = createAsyncThunk("cash/fetchAll", async (params) => {
  const res = await svc.getCashAccounts(params);
  return res.data;
});

export const createCashAccountThunk = createAsyncThunk("cash/create", async (data, { rejectWithValue }) => {
  try {
    const res = await svc.createCashAccount(data);
    return res.data;
  } catch (err) {
    return rejectWithValue(getApiErrorMessage(err, "Failed to create cash account."));
  }
});

export const updateCashAccountThunk = createAsyncThunk("cash/update", async ({ id, data }, { rejectWithValue }) => {
  try {
    const res = await svc.updateCashAccount(id, data);
    return res.data;
  } catch (err) {
    return rejectWithValue(getApiErrorMessage(err, "Failed to update cash account."));
  }
});

const cashSlice = createSlice({
  name: "cash",
  initialState: { list: [], loading: false, error: null },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchCashAccounts.pending, (state) => { state.loading = true; state.error = null; })
      .addCase(fetchCashAccounts.fulfilled, (state, action) => { state.loading = false; state.list = action.payload; })
      .addCase(fetchCashAccounts.rejected, (state, action) => { state.loading = false; state.error = action.error.message; })
      .addCase(createCashAccountThunk.fulfilled, (state, action) => { state.list.push(action.payload); })
      .addCase(updateCashAccountThunk.fulfilled, (state, action) => {
        const id = action.payload.cashID || action.payload.id;
        const idx = state.list.findIndex((c) => (c.cashID || c.id) === id);
        if (idx !== -1) state.list[idx] = action.payload;
      });
  },
});

export default cashSlice.reducer;
